import React from 'react';
import Gallery from './Gallery';
import { useGalleryDroneImages } from '../hooks/useGalleryDroneImages';
import video from '../../img/drone/video/video.mp4'
import poster from '../../img/drone/video/video-poster.webp'

const DynamicDroneGallery: React.FC = () => {
  const { images, config, error } = useGalleryDroneImages();

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '1.2rem',
        color: 'red'
      }}>
        Erreur: {error}
      </div>
    );
  }

  if (!config || images.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '1.2rem'
      }}>
        Aucune image trouvée pour cette galerie.
      </div>
    );
  }

  // Configuration de la vidéo drone
  const droneVideo = {
    src: video,
    poster: poster,
    width: '100%',
    height: '450px'
  };

  return (
    <Gallery
      images={images}
      title={config.title}
      imageSize={{ width: '300px', height: '300px' }}
      bgImage={config.bgImage}
      video={droneVideo}
    />
  );
};

export default DynamicDroneGallery;